/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CompanyLayoutStatusType = "ACTIVE" | "DRAFT" | "%future added value";
export type CompanyLayoutsQueryVariables = {|
  companyId: string
|};
export type CompanyLayoutsQueryResponse = {|
  +Me: ?{|
    +Company: ?{|
      +businessPost: ?{|
        +companyLayouts: ?$ReadOnlyArray<?{|
          +id: string,
          +tableId: number,
          +name: string,
          +layout: string,
          +status: CompanyLayoutStatusType,
        |}>
      |}
    |}
  |}
|};
export type CompanyLayoutsQuery = {|
  variables: CompanyLayoutsQueryVariables,
  response: CompanyLayoutsQueryResponse,
|};
*/


/*
query CompanyLayoutsQuery(
  $companyId: ID!
) {
  Me {
    Company(id: $companyId) {
      businessPost {
        companyLayouts {
          id
          tableId
          name
          layout
          status
        }
      }
      id
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "companyId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "companyId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "BusinessPost",
  "kind": "LinkedField",
  "name": "businessPost",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CompanyLayout",
      "kind": "LinkedField",
      "name": "companyLayouts",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tableId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "layout",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CompanyLayoutsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "Me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "Company",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CompanyLayoutsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "Me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "Company",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "93d5b19fba2055dfa6990caedb3c9ded",
    "id": null,
    "metadata": {},
    "name": "CompanyLayoutsQuery",
    "operationKind": "query",
    "text": "query CompanyLayoutsQuery(\n  $companyId: ID!\n) {\n  Me {\n    Company(id: $companyId) {\n      businessPost {\n        companyLayouts {\n          id\n          tableId\n          name\n          layout\n          status\n        }\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd09715a032e8fbc062c4a66b0a4c7d6f';

module.exports = node;
